import {Component, Inject} from '@angular/core';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({ selector: 'storever-not-found', templateUrl: './not-found.component.html', styleUrls: ['./not-found.component.scss'] })
export class NotFoundComponent {
  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {}
}
